import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";
import { ArrowRight, Rss } from "lucide-react";

const fmtDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return "";
  }
};

export const Blog = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    http
      .get("/blog/articles?limit=50")
      .then((r) => setItems(r.data.items || []))
      .catch((e) => setError(e?.message || "failed to load"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="blog-page" className="mx-auto max-w-7xl px-6 py-16">
      <div className="mb-10 flex items-start justify-between gap-6 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-matrix)] mb-3">
            // module.blog
          </div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl tracking-tight">
            the field notes
          </h1>
          <p className="text-neutral-400 mt-4 max-w-2xl">
            Auto-published articles from our SEO agent. Real research on prompt engineering, model
            behavior, and how to talk to machines.
          </p>
        </div>
        <a
          data-testid="blog-rss"
          href={`${process.env.REACT_APP_BACKEND_URL}/api/blog/rss.xml`}
          target="_blank"
          rel="noreferrer noopener"
          className="inline-flex items-center gap-2 text-[10px] uppercase tracking-widest border border-white/10 hover:border-[color:var(--accent-amber)] hover:text-[color:var(--accent-amber)] px-3 py-2 text-neutral-400 duration-150"
          style={{ transitionProperty: "color, border-color" }}
        >
          <Rss className="w-3 h-3" />
          rss feed
        </a>
      </div>

      {loading && (
        <div data-testid="blog-loading" className="text-neutral-500 text-sm">loading articles...</div>
      )}
      {error && (
        <div data-testid="blog-error" className="text-red-400 text-sm">{error}</div>
      )}

      {!loading && items.length === 0 && !error && (
        <div data-testid="blog-empty" className="border border-white/10 bg-[#0a0a0a] p-12 text-center text-neutral-500 text-sm">
          no articles yet. our SEO agent is warming up — check back soon.
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {items.map((a) => (
          <Link
            key={a.slug}
            to={`/blog/${a.slug}`}
            data-testid={`blog-card-${a.slug}`}
            className="bg-[#0a0a0a] hover:bg-[#111] duration-150 flex flex-col group"
            style={{ transitionProperty: "background-color" }}
          >
            {a.hero_image_url && (
              <div className="aspect-[16/10] overflow-hidden border-b border-white/10 bg-black">
                <img
                  src={a.hero_image_url}
                  alt={a.title}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 duration-500"
                  style={{ transitionProperty: "transform" }}
                />
              </div>
            )}
            <div className="p-6 flex flex-col gap-3 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-amber)]">
                  field notes
                </span>
                <span className="text-[10px] text-neutral-500">{fmtDate(a.published_at)}</span>
              </div>
              <h2 className="font-display font-bold text-lg leading-snug">{a.title}</h2>
              <p className="text-sm text-neutral-400 line-clamp-3">{a.meta_description}</p>
              <div className="mt-auto pt-3 inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-neutral-400 group-hover:text-[color:var(--accent-amber)] duration-150">
                read <ArrowRight className="w-3 h-3" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
